import { RefreshCw, Mail, AlertTriangle } from 'lucide-react';

interface Props {
  eventId?: string | null;
  resetError?: () => void;
  error?: Error | null;
}

export function AppErrorFallback({ eventId, resetError, error }: Props) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center space-y-6">

        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-2xl bg-error/10 flex items-center justify-center">
            <AlertTriangle size={28} className="text-error" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-text-primary">Something went wrong</h1>
          <p className="text-text-secondary text-sm leading-relaxed">
            We're really sorry — an unexpected error has happened. Our team has been notified and is looking into it.
            {eventId && (
              <span className="block mt-1 text-text-tertiary text-xs font-mono">
                Error ID: {eventId}
              </span>
            )}
          </p>
        </div>

        {/* Error detail */}
        {error && (
          <div className="text-left bg-background rounded-xl p-3 border border-border overflow-auto max-h-48">
            <p className="text-xs font-mono text-error break-all whitespace-pre-wrap">{error.message}</p>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={resetError ?? (() => window.location.reload())}
            className="flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-white rounded-xl text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            <RefreshCw size={15} />
            Reload page
          </button>
          <a
            href={`mailto:hello@wedsy.co${eventId ? `?subject=Error%20report%20${eventId}` : ''}`}
            className="flex items-center justify-center gap-2 px-5 py-2.5 border border-border rounded-xl text-sm font-medium text-text-secondary hover:border-primary/50 hover:text-primary transition-colors"
          >
            <Mail size={15} />
            Email us
          </a>
        </div>

      </div>
    </div>
  );
}
